import React, { useState } from "react";
import ProductTable from "../../../../../../../Components/BoltTable/BoltTable";
import { fetchAllBundles } from "../../../../../../../services/ShipperServices/Packages/packages.services";
import {
  BundlePhotoCell,
  BundleWeightCell,
  ContentsCell,
  NameCell,
} from "../Products/LibraryCells";
import { BsPlus } from "react-icons/bs";

export default function BundleListView(props) {
  const { handlescrollpackage, refresh, headerButtons } = props;
  const [bundles, setBundles] = useState([]);

  const columns = [
    // {
    //   id: 0,
    //   label: "#",
    //   render: (row) => <>{row?.id ?? "-"}</>,
    //   width: "200px",
    // },
    // Four columns in the Products list's style (the redesign): the photo as
    // the row's button, Bundle (the old Name), Contents (the old Packages
    // count, with the first package names) and Weight (rounded to 2
    // decimals). LibraryCells.jsx.
    {
      id: 1,
      label: " ",
      render: (row) => <BundlePhotoCell row={row} />,
      fixed: "left",
      width: "60px",
    },
    {
      id: 2,
      label: "Bundle",
      render: (row) => <NameCell row={row} />,
      width: "420px",
    },
    {
      id: 3,
      label: "Contents",
      render: (row) => <ContentsCell row={row} />,
      width: "300px",
    },
    {
      id: 4,
      label: "Weight",
      render: (row) => <BundleWeightCell row={row} />,
      width: "160px",
    },
    // {
    //   id: 6,
    //   label: "Quantity",
    //   render: (row) => (
    //     <>
    //       <div className="product_quantity_parent_wrapper">
    //         <div className="product__textalign_center">
    //           {row?.product_warehouse?.reduce(
    //             (total, warehouse) =>
    //               total + parseInt(warehouse.quantity, 10) || 0,
    //             0
    //           )}
    //         </div>
    //       </div>
    //     </>
    //   ),
    //   width: "200px",
    // },
    // {
    //   id: 8,
    //   label: "Actions",
    //   render: (row) => (
    //     <>
    //       {" "}
    //       <div className="table_action__wrap">
    //         <div
    //           className="table_action__btn"
    //           onClick={() => handlescrollpackage(row)}
    //         >
    //           <BsPlus size={10} />
    //           Add
    //         </div>
    //       </div>
    //     </>
    //   ),
    //   width: "200px",
    // },
  ];

  const getAllBundles = async (page, perPage, filter) => {
    const response = await fetchAllBundles(page, perPage, filter);
    if (!response.error) {
      setBundles(response?.data?.result);
    } else {
    }
  };

  return (
    <>
      <div className="custom__table_size1 actionbtn__needtobe_fixwidth">
        <ProductTable
          tableId="bundleListViewTableforShipper_v2"
          message={"No Bundles Available To Display!"}
          searchPlaceHolder={"Search Bundles"}
          getAllData={getAllBundles}
          data={bundles}
          columns={columns}
          refresh={refresh}
          handleRowClick={handlescrollpackage}
          isRowClick="Click To Add"
          disableAutoResizing={true}
          headerButtons={headerButtons}
        />
      </div>
    </>
  );
}
